import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
// import { useTranslation } from 'react-i18next';
import Typography from '@clasohlson/co-ui-components/Typography';
import Stack from '@clasohlson/co-ui-components/Stack';
import Grid from '@clasohlson/co-ui-components/Grid';
import Column from '@clasohlson/co-ui-components/Column';
import Modal from '@clasohlson/co-ui-components/Modal';
import Divider from '@clasohlson/co-ui-components/Divider';
import Box from '@clasohlson/co-ui-components/Box';
import { OrderOverview } from '../components/order/OrderOverview';
import {
  useGlobalStateValue,
  ADD_OR_UPDATE_RETURN,
  REMOVE_RETURN,
  RESET_STATE,
  SET_RETURN_QUERY,
} from '../store/globalState';
import { LineItem } from '../orderModel';
import { ReturnProduct } from '../components/order/ReturnProduct';
import customTheme from '../theme';
import { Process } from '../components/order/Process';
import { IReturn } from '../models';
import { OrderHeader } from '../components/order/OrderHeader';
import { postReturns } from '../api';
import { CustomButton } from '../components/button/CustomButton';
import { CustomTextfield } from '../components/textfield/CustomTextfield';
import { useTranslation } from '../utils';
import RetTypography from '../components/layout/RetTypography';
import { ButtonRow } from '../components/layout/ButtonRow';
// import { Error } from '../components/layout/Error';
// import { getLanguage } from '../utils';

const ProcessTitle = styled.div<ProcessTitleProps>`
  font-weight: 600;
  font-size: 16px;
  line-height: 3.19;
  text-align: center;
  color: #000;
  //color: ${({ allValid }) => (allValid ? '#33a641' : customTheme.colors.text)};
  @media screen and (max-width: 640px) {
    font-size: 14px;
    line-height: 1.29;
  }
`;

const ReturnProductList = styled.div`
  > div {
    margin-bottom: 1rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const StyledModal = styled(Modal)`
  overflow: visible;
  & > button {
    border-radius: 50%;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    width: 2.9375rem;
    height: 2.9375rem;
    top: -0.5rem;
    right: -0.5rem;
    background: #fff;
    svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;

interface ProcessTitleProps {
  allValid: boolean;
}

export const ReturnDetails = () => {
  const {
    state: { currentOrder, returns, returnQuery },
    dispatch,
  } = useGlobalStateValue();

  // console.log(returns);
  // console.log(returnQuery);

  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [sendError, setSendError] = useState<boolean>(false);
  const [emailValid, setEmailValid] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSent, setIsSent] = useState<boolean>(false);

  const emailRef = useRef<HTMLInputElement>(null);

  const history = useHistory();
  const { t } = useTranslation();

  const handleReturnChange =
    (rowNumber: number, qtyToReturn: number) =>
    (
      // qtyToReturn: number,
      action: string,
      reason: string,
      notes?: string,
    ) => {
      const ret: IReturn = { rowNumber, qtyToReturn, action, reason, notes };
      dispatch({ type: ADD_OR_UPDATE_RETURN, payload: ret });
    };

  const rowShouldBeReturned = (rowNumber: number): boolean =>
    returns ? returns.some((r) => r.rowNumber === rowNumber) : false;

  const rowIsValid = (row: IReturn | undefined): boolean => {
    if (row && row.reason && row.action && row.notes && row.qtyToReturn) return true;
    return false;
  };

  const allRowsAreValid = (): boolean => {
    let valid = true;
    let queryIsValid = true;
    returns.forEach((ret) => {
      if (!rowIsValid(ret)) valid = false;
    });
    if (currentOrder && currentOrder.state === 'Obfuscated') {
      queryIsValid = Boolean(
        returnQuery &&
          typeof returnQuery.email !== 'undefined' &&
          typeof returnQuery.name !== 'undefined' &&
          returnQuery.name !== '' &&
          returnQuery.email !== '' &&
          emailValid,
      );
    }
    return valid && queryIsValid;
  };

  const someRowsAreValid = (): boolean => {
    let valid = false;
    returns.forEach((ret) => {
      if (rowIsValid(ret)) valid = true;
    });
    return valid;
  };

  const getProcessWidth = (): number => {
    if (allRowsAreValid()) {
      return 98;
    } else if (someRowsAreValid()) {
      return 75;
    }
    return 50;
  };

  const deleteArticle = (rowNumber: number) => {
    const del = confirm(t('deleteRowConfirm'));

    if (del) dispatch({ type: REMOVE_RETURN, payload: rowNumber });
  };

  const sendReturn = async () => {
    if (allRowsAreValid() && returnQuery) {
      setIsLoading(true);
      try {
        setSendError(false);
        const res = await postReturns(returnQuery, returns);
        if (res && res.status === 200) {
          setModalVisible(true);
        }
      } catch (e) {
        setSendError(true);
        setModalVisible(true);
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleModalClose = () => {
    setModalVisible(false);
    if (!sendError) {
      dispatch({ type: RESET_STATE, payload: undefined });
      setIsSent(true);
      //history.push('/');
      window.location.href = window.location.origin;
    } else {
      setSendError(false);
    }
  };

  const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => {
    const newReturnQuery = { ...returnQuery };
    newReturnQuery[e.currentTarget.id] = e.currentTarget.value;
    dispatch({ type: SET_RETURN_QUERY, payload: newReturnQuery });
    // if(e.currentTarget.id === 'email') setEmail(e.currentTarget.value);
  };

  // const getOriginalMax = (id: string): number => {
  //   if (currentOrder) {
  //     return currentOrder.lineItems.find((lt) => lt.id === id)?.deliveredQuantity || 1;
  //   }
  //   return 1;
  // };

  useEffect(() => {
    if (!isSent && (!returns || returns.length === 0)) {
      history.goBack();
    }
  }, [returns, isSent]);

  useLayoutEffect(() => {
    const valid = emailRef?.current?.checkValidity() || false;
    setEmailValid(valid);
  }, [returnQuery]);
  return (
    <React.Fragment>
      {/* <ReturnProductList spacing="xlarge"> */}
      <OrderHeader />
      {currentOrder && <OrderOverview order={currentOrder} />}
      <ProcessTitle allValid={allRowsAreValid()}>
        {allRowsAreValid() && t('stepThreeTitle')}
        {!allRowsAreValid() && t('stepTwoTitle')}
      </ProcessTitle>
      <Process
        allDone={allRowsAreValid()}
        steps={3}
        activeStep={allRowsAreValid() ? 3 : 2}
        percentLine={getProcessWidth()}
      />
      {allRowsAreValid() && (
        <Grid spacing="large">
          <Column lg="4" md="4" sm="6" xs="12" lgOffset="4" mdOffset="4" smOffset="3">
            <CustomButton
              onClick={() => sendReturn()}
              disabled={!allRowsAreValid() || isLoading}
              fullWidth
            >
              {t('send')}
            </CustomButton>
            <Divider spacing="medium" color="#FFFFFF" />
          </Column>
        </Grid>
      )}
      <ReturnProductList>
        {currentOrder &&
          currentOrder.lineItems.map((prod: LineItem, idx: number) => {
            if (rowShouldBeReturned(prod.rowNumber)) {
              const currentReturn = returns.find((ret) => ret.rowNumber === prod.rowNumber);
              return (
                <div key={`div-${prod.sku}`}>
                  <ReturnProduct
                    max={prod?.deliveredQuantity || 1}
                    key={prod.sku}
                    index={idx}
                    isValid={rowIsValid(currentReturn)}
                    product={prod}
                    deleteArticle={deleteArticle}
                    handleReturnChange={handleReturnChange(
                      prod.rowNumber,
                      currentReturn?.qtyToReturn || 0,
                    )}
                  />
                </div>
              );
            }
            return null;
          })}
      </ReturnProductList>
      {currentOrder && currentOrder.state === 'Obfuscated' && (
        <Box topSpacing="large" bottomSpacing="large">
          <Grid spacing="large">
            <Column lg="6" md="6" sm="6" xs="12">
              <CustomTextfield
                label={t('email')}
                id="email"
                type="email"
                onChange={handleInputChange}
                forwardRef={emailRef}
                required
                hideRequiredLabel
                data-testid="obfuscated-email"
              />
            </Column>
            <Column lg="6" md="6" sm="6" xs="12">
              <CustomTextfield
                label={t('name')}
                id="name"
                onChange={handleInputChange}
                required
                hideRequiredLabel
                data-testid="obfuscated-name"
              />
            </Column>
          </Grid>
        </Box>
      )}
      <Divider color="#FFFFFF" spacing="xsmall" />
      <ButtonRow
        prevTitle={t('goBack')}
        nextTitle={t('send')}
        prevAction={() => history.goBack()}
        nextAction={() => sendReturn()}
        canGoNext={allRowsAreValid() && !isLoading}
        nextTestId="sendReturnButton"
      />
      <StyledModal visible={modalVisible} onClose={handleModalClose}>
        {!sendError && (
          <Box
            topSpacing="xlarge"
            bottomSpacing="xlarge"
            leftSpacing="xlarge"
            rightSpacing="xlarge"
          >
            <Stack spacing="large" alignItems="center" justifyContent="center">
              <RetTypography
                weight="bold"
                fontSize="28px"
                lineHeight="1.25"
                align="center"
                mobileFontSize="20px"
                mobileLineHeight="35px"
              >
                {t('returnSentTitle')}
              </RetTypography>
              {/* <Typography variant="p" tag="p" align="center">
              Vi har skickat en bekräftelse och sammanfatting till{' '}
              <strong>e-postadressen som användes vid ursprungsbokningen av denna order.</strong>
            </Typography> */}

              <Typography variant="p" tag="p" align="center" paragraph>
                {t('returnSentDescription')}
              </Typography>
              {/* {getLanguage() === 'se' && (
                <Error>
                  Just nu har vi längre hanteringstid än normalt, men vi återkommer till dig så
                  snart som möjligt.
                </Error>
              )} */}

              <CustomButton
                onClick={() => handleModalClose()}
                data-testid="closeSuccessModalButton"
              >
                {t('returnSentCloseBtn')}
              </CustomButton>
            </Stack>
          </Box>
        )}
        {sendError && (
          <Stack spacing="large" alignItems="center" justifyContent="center">
            <Typography variant="h3" tag="h3" align="center" color={customTheme.colors.error}>
              {t('returnNotSentTitle')}
            </Typography>
            <Typography variant="p" tag="p" align="center">
              {t('returnNotSentDescription')}
            </Typography>
            <CustomButton onClick={() => handleModalClose()}>
              {t('returnNotSentCloseBtn')}
            </CustomButton>
          </Stack>
        )}
      </StyledModal>
    </React.Fragment>
  );
};
